import { useState } from 'react';

const faqs = [
  {
    q: '麻豆cm传媒在线高清平台是否需要付费？',
    a: '麻豆cm传媒在线高清平台提供大量免费高清视频内容，用户注册后即可免费在线观看。部分独家内容可能需要VIP会员权限，但核心资源库对全体用户开放，让您畅享高清视听体验。',
  },
  {
    q: '支持哪些设备观看高清视频？',
    a: '我们的平台支持多终端播放，包括电脑（Windows/Mac）、平板（iPad/Android平板）和手机（iOS/Android）。只需一个账号，即可在不同设备间无缝切换，随时随地享受高清视频。',
  },
  {
    q: '视频画质最高支持多少分辨率？',
    a: '麻豆cm传媒平台最高支持4K超高清分辨率播放，同时提供1080P、720P等多种画质选项。系统会根据您的网络状况自动调整最佳画质，确保流畅的观看体验。',
  },
  {
    q: '如何下载视频到本地观看？',
    a: 'VIP会员可以在移动端App中将视频缓存到本地，方便在无网络环境下观看。缓存视频支持选择不同画质，您可以根据设备存储空间灵活选择。',
  },
  {
    q: '平台的内容多久更新一次？',
    a: '我们每天更新最新的高清视频内容，确保用户始终能够获取最新、最热门的高清资源。每周五还会有专题推荐和独家首发内容上线。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[800px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500 mt-2">关于平台使用的常见疑问解答</p>
        </div>

        <div className="flex flex-col gap-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
              >
                <span className="font-heading font-semibold text-foreground-900 text-sm pr-4">{faq.q}</span>
                <div className={`w-6 h-6 flex items-center justify-center rounded-full transition-all flex-shrink-0 ${openIndex === index ? 'bg-primary-500 text-background-50 rotate-45' : 'bg-background-100 text-foreground-500'}`}>
                  <i className="ri-add-line text-sm"></i>
                </div>
              </button>
              {openIndex === index && (
                <div className="px-5 pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}